import { request } from '@/utils/request'

export function listAgreement(data) {
  return request({
    url: '/platform/agreement/maintain/latest',
    method: 'get',
    params: data
  })
}